import { useTranslation } from 'react-i18next';
import styles from './checkoutLayout.module.scss';
import { matchPromo } from './data';
import { MedalIcon } from './icons';
import { Stars } from './primitives';

export function TrustBox() {
  const { t } = useTranslation();

  return (
    <div className={styles.trustBox}>
      <div className={styles.trustTitle}>{t(matchPromo.trust)}</div>
      <div className={styles.trustRow}>
        <div className={styles.trustRating}>
          <Stars rating={matchPromo.rating} />
          <div className={styles.trustReviews}>
            {t('{{rating}} based on {{reviews}} reviews', {
              rating: matchPromo.rating,
              reviews: matchPromo.reviews,
            })}
          </div>
        </div>
        <MedalIcon className={styles.medal} />
      </div>
    </div>
  );
}
